import { render, staticRenderFns } from "./ServiceStatistics.vue?vue&type=template&id=4cdbda22"
import script from "./ServiceStatistics.vue?vue&type=script&lang=ts"
export * from "./ServiceStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports